import MobileTitleBar from "components/MobileTitleBar"
import Price from "components/Price/Price"
import Badge from "components/Product/Badge"
import ProductCard from "components/Product/ProductCard"
import ProductFullscreen from "components/Product/ProductFullscreen"
import ProductImages from "components/Product/ProductImages"
import ProductList from "components/Product/ProductList"
import ProductPrice from "components/Product/ProductPrice"
import ProductQuantityGroup from "components/Product/ProductQuantityGroup"
import ProductSearch from "components/Product/ProductSearch"
import ProductSearchExtra from "components/Product/ProductSearchExtra"
import ProductPath from "components/ProductPath"
import Variants from "components/Variants/Variants"
import {Col, Row} from "elemental-react16"
import _ from "lodash"
import PropTypes from "prop-types"
import React, {Component} from "react"
import Responsive from "react-responsive"
import {Link} from "react-router-dom"
import {Button, Card, Container, Icon, Image, Input, Message, Popup, Select, Table} from "semantic-ui-react"
import shop from "shop/shop"
import queryString from "qs"
import productStore from "stores/productStore"
import "style/ProductPage.scss"
import categoryStore from "stores/categoryStore"
import ProductSearchBasic from "components/Product/ProductSearchBasic"

let lastProducts = null

const IconImage = ({src, description}) => <Popup content={description}
                                                 trigger={<img className="mr2 icon-product-attribute" width="42"
                                                               src={src} alt=""/>}/>

export default class ProductPage extends Component {

    componentWillUnmount() {
        document.body.classList.remove("no-scroll")
    }

    constructor(props) {
        const {match} = props
        super()
        this.state = {
            id: match.params.productId,
            product: {},
            fullscreenElement: null,
            variants: false,
            count: 1
        }
    }

    loadProduct(id) {
        if (this.id === id) return
        this.id = id
        productStore.get(id)
            .then(product => {
                console.log("ProductPage::product", product)
                product.count = 1
                let inCart = shop.cart.productsById.get(product.map_id)
                if (inCart) product.count = Number(inCart.count)
                shop.analytics.push(product.map_id)
                lastProducts = shop.analytics.lastProducts(4)
                    .filter((id) => id !== product.map_id)
                this.setState({product: product, count: product.count, primaryImage: false})

                if (!product.mainart) return
                productStore.partlist(product.mainart)
                    .then(variants => {

                        // let colors = variants.products.map( product => {
                        //   return {
                        //     color:  product.extras.Farbe,
                        //     map_id: product.map_id
                        //   }
                        // } )

                        let byAttribute = {}
                        variants.variants.varfields.forEach(varfield => {
                            let categories = _.groupBy(variants.products, `extras.${varfield}`)
                            var ordered = {};
                            _(categories).keys().sort().each(function (key) {
                                ordered[key] = categories[key];
                            });
                            byAttribute[varfield] = ordered

                        })
                        this.setState({variants, byAttribute})
                    })
            })
            .catch(err => {
                console.error(`Product not available ${id}`)
                console.error(err)
                this.setState({error: true})
            })
    }

    add = ({product}) => {
        //if ( product.count === 0 ) return shop.cart.remove( product )
        shop.toast(`${product.count} x VE ${product.unit_multi} ${product.title} hinzugefügt`, "info", false, "bottom")
        return shop.cart.add(product)
    }

    updateProduct = ({product}) => {
        this.setState({product})
    }

    componentWillReceiveProps({match}) {
        let {productId} = match.params
        this.loadProduct(productId)
    }

    showFullscreen = (element) => {
        this.setState({
            fullscreenElement: element
        })
    }

    setPrimaryImage = (primaryImage) => {
        this.setState({primaryImage})
    }

    componentDidMount() {
        this.loadProduct(this.state.id)
    }

    render() {
        let {fullscreenElement, product, byAttribute, primaryImage, count, error} = this.state


        if (error) return <div className={"vh-75 tc flex justify-center items-center"}>
            <div>
                <h3>404</h3>
                <div>Produkt nicht gefunden</div>
            </div>
        </div>

        if (!product._type) return null //  duck type check for ProductModel
        let img_srcs = product.img_srcs

        let category = product.cats[0] && product.cats[0] || {}
        let cat_id = category.cat_id

        let productImage
        if (product.img_src) {
            productImage = product.img_src_large
        }

        if (primaryImage) productImage = primaryImage

        // let categoryName = shop.categoryName(product.cats[0].cat_id)
        let path = shop.getCategoryPath(cat_id)

        path.push({
            title: product.title,
            link: ""
        })


        const veOptions = product.quantities.map(q => {
            return (
                {
                    key: q.map_desc_id,
                    text: `${q.des} (${q.multi})`,
                    value: q.map_desc_id
                }
            )
        })
        // const veOptions = [
        //   { key: 'all', text: 'All', value: 'all' },
        //   { key: 'articles', text: 'Articles', value: 'articles' },
        //   { key: 'products', text: 'Products', value: 'products' },
        // ]

        const query = queryString.parse(this.props.location.search.substr(1))

        let themeCategory = null
        if (query.template === "themenwelt") {
            themeCategory = categoryStore.categoryByProductId.get(product.article_nr)
        }
        let maxCount = Math.max(0, Math.floor(Number(product.extras.orderable_value) /product.unit_multi))
        let showVEWarning = shop.config.checkout.limitToStock && (count > maxCount) && !product.categoryDict["23"]

        if (product.extras.orderable_value === "0") {
            maxCount = 0
            showVEWarning = true
        }

        if (product.extras.orderable_value === "" || product.extras.orderable_value === undefined) {
            maxCount = 999999999999
            showVEWarning = false
        }

        return (
            <div className="bg-white ">

                <MobileTitleBar>
                    <ProductPath path={path} title={product.title} product={product}/>
                </MobileTitleBar>


                {/* THEMEWORLD TEMPLATE */}
                {themeCategory && <React.Fragment>

                    <Container className={"pv4"}>

                        <div className="flex flex-row ">
                            <div className="pb4 w-100 self-center relative ">
                                <Responsive minWidth={790}>
                                    <div className="absolute left-0 top-0  z-999">
                                        <ProductPath path={path} title={product.title} product={product}/> 
                                    </div>
                                </Responsive>
                                <div className="pa4 relative">
                                    <Image width={620} centered src={product.img_src_large}/>
                                    <div className="absolute left-1 top-1 pt5">
                                        <h1 className={"b ma0 pb1 f0"}>{product.title}</h1>
                                        <div className={"f3 "}>{product.category.title}</div>
                                    </div>
                                </div>
                            </div>

                            {/*<ProductCollection maxCount={maxCount} product={product} categoryId={themeCategory.map_id} />*/}

                        </div>

                        <ProductSearchBasic title={product.title}
                                            cats={[themeCategory.map_id]}
                                            count={42}
                                            repeat={(props) => <ProductCard {...props} query={{
                                                referrerTitle: product.title,
                                                referer: `${this.props.location.pathname}${this.props.location.search}`
                                            }}/>}/>

                    </Container>

                    {/*<div className="bg-silver  pv4">*/}
                    {/*	<Container className="">*/}
                    {/*		{product.category && <div className="pv4">*/}
                    {/*			<Container>*/}
                    {/*				<section className="section-product-slider">*/}
                    {/*					<div className="cf relative pb3">*/}
                    {/*						{product.category.desc && <Button basic as={Link} to={`/collection/${product.category.map_id}`}><h2*/}
                    {/*							className="mt2 ttu">{`Weitere Deko-Ideen:  ${product.category.desc.des ||*/}
                    {/*						product.category.desc.short_des}`} <Icon name="chevron right" /></h2>*/}
                    {/*						</Button>}*/}
                    {/*					</div>*/}

                    {/*					<ProductSearch*/}
                    {/*						count={42}*/}
                    {/*						start={0}*/}
                    {/*						cats={[cat_id]}*/}
                    {/*						query="%%"*/}
                    {/*						repeat={ProductCard} />*/}
                    {/*				</section>*/}
                    {/*			</Container>*/}
                    {/*		</div>}*/}
                    {/*	</Container>*/}
                    {/*</div>*/}

                </React.Fragment>
                }

                {!themeCategory && <React.Fragment>
                    <Container className="relative  ">
                        <ProductFullscreen
                            change={this.showFullscreen}
                            images={img_srcs}
                            image={fullscreenElement}/>

                        <Responsive minWidth={790}>
                            <div className="db pv3 ">
                                <ProductPath path={path} title={product.title} product={product}/> 
                            </div>
                        </Responsive>

                        {/*<Breadcrumbs path={path}/>*/}
                        <section className="product product-single pb6-ns pb5">
                            <Row>
                                <Col sm="1" md="1/2" lg="7/12" className="relative">
                                    <div className="absolute right-2 pr3"><Badge product={product}/></div>
                                    <ProductImages
                                        key={product.map_id}
                                        product={product} images={img_srcs} image={productImage}
                                        onClick={this.showFullscreen}
                                        onClickSecondary={this.setPrimaryImage}/>
                                </Col>
                                <Col sm="1" md="1/2" lg="5/12">
                                    <TitleSection product={product}/>

                                    {(shop.session && maxCount > 0) &&
                                    <div className="product-actions">
                                        {product &&
                                        <React.Fragment>
                                            <Input type="number" min={0} placeholder="1" value={count} action onChange={e => {
                                                const count = e.target.value
                                                let ok = product.onChange(product)
                                                if (!ok) {
                                                    console.warn("ABNAHME ERREICHT", count, product)
                                                    return false
                                                }
                                                this.setState({count: e.target.value})
                                            }
                                            }>
                                                <input/>
                                                <Select key={product.map_id} compact options={veOptions} defaultValue={product.quantities && product.quantities[0].map_desc_id}
                                                        onChange={(e, data) => {
                                                            const {value} = data
                                                            const ve = product.quantities.filter(q => q.map_desc_id === value)
                                                            if (!ve) return
                                                            product.unit_multi = ve[0].multi
                                                            product.unit_id = ve[0].map_desc_id
                                                            this.setState({product})

                                                            console.log({data, e, value: e.target.value, target: e.target})
                                                        }
                                                        }
                                                />
                                            </Input>

                                            <Button color={"black"} onClick={() => {
                                                let count = this.state.count
                                                if (!product.categoryDict[23]) {
                                                    count = Math.min(Math.floor(product.stock / product.unit_multi), this.state.count)
                                                    count = Math.max(0, count)
                                                }

                                                if (product.extras.orderable_value === "0") return null

                                                product.count = count
                                                this.setState({count, product}, () => {
                                                    console.info("BUY", this.state.count, product.count, product.unit_multi, product.unit_id)
                                                    product.count = product.count || 1
                                                    this.add({product})
                                                })
                                            }
                                            }>
                                                <div className="tc ph3"><Icon name={"shopping cart"}/></div>
                                            </Button>
                                        </React.Fragment>}



                                        {showVEWarning &&
                                        <Message color={"yellow"} className={"cf"}>
                                            <Button color={"yellow"} floated={"right"} onClick={() => {
                                                product.count = maxCount
                                                let count = maxCount
                                                this.setState({count, product})
                                            }}>Ok</Button>

                                            <div className="pt2"><Icon name="warning"/> {`Maximale Abnahmemenge: ${maxCount} ${product.unit_desc}`}</div>

                                            {/*<Popup trigger={<Button  icon="warning" color="yellow" title={`Maximale Abnahmemenge: ${maxCount} VE`}/>}*/}
                                            {/*       content={`Maximale Abnahmemenge: ${maxCount} ${product.unit_id}}`}/>*/}
                                        </Message>

                                        }
                                    </div>}


                                    {shop.session && <BulkPricing product={product}/>}
                                    {!shop.session && <div>
                                        <p>
                                            {translate("shop.please_login_for_product_details")}
                                        </p>

                                        <div className="mw6">
                                            <div className="pb2">
                                                <Link to="/login"><Button fluid> {translate("shop.login")}</Button></Link>
                                            </div>
                                            <Link to="/customer_registration"><Button fluid> {translate("shop.register")}</Button></Link>
                                        </div>
                                    </div>}
                                    {shop.session && <TechnicalTable product={product}/>}
                                    <HtmlDescriptionSection product={product}/>

                                    <br/>
                                    <br/>
                                    <section>
                                        <Variants byAttribute={byAttribute} product={product}/>
                                        {/*{variants && variants.products && variants.products.map( variant => <ProductVariant key={variant.map_id} product={variant}/> )}*/}
                                        {/*<pre>{JSON.stringify( variants && variants.variants.varfields, null, 2 )}</pre>*/}
                                    </section>
                                </Col>
                            </Row>
                        </section>
                    </Container>

                    {product.extras.Kollektion && <div className="bg-silver pv4">
                        <Container>
                            <section className=" pt3 pb5">

                                <div className="cf relative pb3">
                                    {product.category.desc &&
                                    <Link to={`/collection-extra/Kollektion/${product.extras.Kollektion}`}><h2
                                        className="mt2 ttu">{`${translate("Mehr aus Kollektion")}  ${product.extras.Kollektion}`} <Icon
                                        name="chevron right"/></h2>
                                    </Link>}
                                </div>

                                <ProductSearchExtra
                                    count={4}
                                    start={0}
                                    extra={"Kollektion"}
                                    extraValue={product.extras.Kollektion}
                                    query="%%"
                                    repeat={ProductCard}/>
                            </section>

                        </Container>
                    </div>}

                    {product.category && <div className="pv4">
                        <Container>
                            <section className="section-product-slider">
                                <div className="cf relative pb3">
                                    {product.category.desc && <Button basic as={Link} to={`/collection/${product.category.map_id}`}><h2
                                        className="mt2 ttu">{`${translate("Mehr aus")} ${product.category.desc.des ||
                                    product.category.desc.short_des}`} <Icon name="chevron right"/></h2>
                                    </Button>}
                                </div>

                                <ProductSearch
                                    count={4}
                                    start={0}
                                    cats={[cat_id]}
                                    query="%%"
                                    repeat={ProductCard}/>
                            </section>
                        </Container>
                    </div>}

                </React.Fragment>}


                <div className="pv4 bg-silver">
                    <Container>
                        {/*Product Slider "last viewed"*/}
                        <section className="section-product-slider pv5">
                            <h2 className="mt2  ttu">{translate("Zuletzt angesehen")}</h2>
                            <ProductList
                                count={4}
                                start={0}
                                list={lastProducts}
                                repeat={ProductCard}/>
                        </section>
                    </Container>
                </div>
            </div>
        )
    }
}

ProductPage.propTypes = {
    price: PropTypes.any
}


function PImage({src}) {
    return <Image key={src} height={40} src={src}/>
}


function ProductCollection({product, categoryId, maxCount}) {

    const [count, setCount] = React.useState(0)
    const [countById, setCountById] = React.useState(new Map())
    const [productById, setProductById] = React.useState(new Map())

    const updateGlobalCount = (count) => {
        count = Math.max(0, count);
        count = Number(count);
        if (typeof count !== "number") return

        [...countById.keys()].map(key => {
            countById.set(key, count)
        })
        setCount(count)
    }

    const updateMap = (k, v) => {
        setCountById(new Map(countById.set(k, v)))
    }

    const showVEWarning = maxCount < count

    return <div className="ProductCollection pa4-ns w-100 bg-silver flex flex-column justify-between">
        <div>
            <h2 className={""}>{product.title}</h2>

            <ProductSearchBasic
                onLoad={({products}) => {
                    products.forEach(p => {
                        countById.set(p.map_id, 0)
                        productById.set(p.map_id, p)
                    })
                    console.log({products})
                }}
                static
                key={categoryId}
                cats={[categoryId]}
                count={42}
                displayMode={"custom"}
                repeat={({product}) => <div key={product.map_id} className="pv3  ph3 mb2 bg-white flex flex-row items-center justify-between">
                    <div className={"flex flex-row items-center"}>
                        {/*TODO: FIX HEADERS ON IMAGES */}
                        {/*<div style={{width: "45px"}} className={"pr2"}><PImage key={product.map_id} src={product.img_src_small}/></div>*/}
                        <div>
                            <div>{product.title}</div>
                            <div className={"black-60"}>{product.article_nr}</div>
                        </div>
                    </div>
                    <div className={"flex flex-row items-center"}>
                        <div className={"pr3 tr"}>
                            <div><Price>{product.price * product.unit_multi}</Price></div>
                            <div className={"black-60 f5"}>{product.unit_multi} Stk.</div>
                        </div>
                        <Input defaultValue={countById.get(product.map_id)} onBlur={(e) => {
                            const value = e.target.value
                            setTimeout(() => {
                                updateMap(product.map_id, value)
                            }, 500)
                        }} className={"tc"} style={{width: "60px"}}/>
                    </div>
                </div>}/>

            <div className="flex flex-row pb4 pt4 items-center justify-between">
                <h3>Deko-Idee in den Warenkorb legen</h3>
                <div className={"flex flex-row items-center"}>
                    <Button onClick={() => updateGlobalCount(count - 1)} icon={"minus"}/>
                    <Button onClick={() => updateGlobalCount(count + 1)} icon={"plus"}/>
                    <div className=""><Input value={count} style={{width: "120px"}}/></div>
                </div>
            </div>
        </div>

        {/*{showVEWarning && <Message color="yellow">*/}
        {/*	Maximale Abnahmemenge: {maxCount} VE*/}
        {/*</Message> }*/}

        <div className="pt3 flex flex-row justify-end">
            <Button primary onClick={() => {
                // product.count = count
                // shop.cart.add(product, {collection: true});

                // THIS PUTS EVERY SUB PRODUCT IN CAR: PACKING UNITS WILL NOT WORK
                [...productById.values()].forEach(p => {
                    let count = countById.get(p.map_id)
                    p.count = count || 0
                    shop.cart.add(p, {collectionId: product.map_id})
                })
            }}>
                <Icon name={"shopping cart"}/>
                in den Warenkorb
            </Button>
        </div>
    </div>
}


const ProductVariant = ({product}) => {
    return (
        <Card as={Link} to={`/product/${product.map_id}`}>
            <img className="ui image" src={product.img_src_medium}/>
            <div>{product.extras.Art}</div>
            <div>{product.extras.Groesse}</div>
        </Card>
    )
}

const BulkPricing = ({product}) => {
    if (!product.prices || product.prices.length === 1) return null
    return (

        <div>
            <h4>{translate("Staffelpreise")} </h4>
            <Table>
                <tbody>
                {product.prices.map(price => (
                    <tr key={price.q}>
                        <td>{translate("ab")} {price.q} {translate("Stück")}</td>
                        <td><Price>{price.p}</Price></td>
                    </tr>
                ))}
                </tbody>
            </Table>

        </div>
    )
}

const Fullscreen = ({image, change, images}) => {
    document.body.classList.remove("no-scroll")
    if (!image) {
        return null
    }
    window.scrollTo && window.scrollTo(0, 0)
    const imgs = _.map(images, ({img_src_large, img_src_small}, key) => {
        return (
            <img key={key}
                 onClick={() => {
                     change(img_src_large)
                 }}
                 className="img-thumbnail "
                 src={img_src_small}/>
        )
    })

    document.body.classList.add("no-scroll")
    return (
        <div className="fullscreen">
            <div className="ui pull-right"
                 style={{position: "relative"}}>
                <Button icon="close"
                        basic
                        onClick={() => {
                            change(false)
                        }}/>
            </div>

            <div className="center-child "
                 onClick={() => {
                     change(false)
                 }}>
                <div className="zoom-out img-container">
                    <img src={image} alt=""/>
                </div>
            </div>

            <div className="ui ui-bottom pull-right ">
                <div className="product-images">
                    {imgs}
                </div>
            </div>
        </div>
    )
}

Fullscreen.propTypes = {
    children: PropTypes.object, change: PropTypes.func, images: PropTypes.array
}

const TechnicalTable = ({product}) => {
    
    const lang = window.languageStore.currentLanguage;

    return (
        <div className="pt4">
            <h4>Details</h4>
            <Table>
                <tbody>

                {product.extras.uvstabil && <tr>
                    <td>UV-Stabil</td>
                    <td><Icon name={"check circle"}/></td>
                </tr>}

                {product.quantities[0] &&
                <tr key={product.quantities[0].map_desc_id}>
                    <td>
                        <label>
                            {product.quantities[0].des}
                        </label>
                    </td>
                    <td>
                        {product.quantities[0].multi} {translate("product.piece")}
                    </td>
                </tr>
                }

                {product.quantities[1] &&
                <tr key={product.quantities[1].map_desc_id}>
                    <td>
                        <label>
                            {product.quantities[1].des}
                        </label>
                    </td>
                    <td>
                        {product.quantities[1].multi} {translate("product.piece")}
                    </td>
                </tr>
                }

                <tr>
                    <td>
                        <label>
                            EAN
                        </label>
                    </td>
                    <td>
                        {product.barcode}
                    </td>
                </tr>
                {(product.extras.farbe_de && product.extras.farbe_de !== 'null') && 
                <tr>
                    <td>
                        <label>{translate("Farbe")}</label>
                    </td>
                    <td>
                        {lang == 'de' ? product.extras.farbe_de : product.extras.farbe_en}
                    </td>
                </tr>}
                {(product.extras.katalog_de && product.extras.katalog_en !== 'null') &&
                <tr>
                    <td>
                        <label>{translate("Sonstiges")}</label>
                    </td>
                    <td>{lang == 'de' ? product.extras.katalog_de : product.extras.katalog_en}</td>
                </tr>}
                {product.extras.verwendung && 
                <tr>
                    <td>
                        <label>{translate("verwendung")}</label>
                    </td>
                    <td>
                        {product.extras.verwendung}
                    </td>
                </tr>
                }
                <tr>
                    <td>
                        <label>{translate("hersteller")}</label>
                    </td>
                    <td>
                        {product.extras.hersteller}
                    </td>
                </tr>
                </tbody>
            </Table>
        </div>
    )
}

TechnicalTable.propTypes = {
    product: PropTypes.object
}

const AdditionalTable = ({product}) => {
    return (
        <section className="AdditionalTable">
            <Row>
                <Col sm="1" md="1" className="pb3">
                    <div className="technischetabelle">
                        <strong>weitere Details</strong>
                        <table className="table-technical">
                            <tbody>
                            {product && shop.session.group !== "WERBE" ? <tr>
                                <td>UVP inkl. MwSt.</td>
                                <td className="text-right"><Price className="fw1">{product.extras.evkpre}</Price></td>
                            </tr> : null}
                            {product && shop.session.group === "WERBE" ? <tr>
                                <td>Industriepreis Netto</td>
                                <td className="text-right"><Price className="fw1">{product.extras.indpre}</Price></td>
                            </tr> : null}
                            {product ? <tr>
                                <td>EAN</td>
                                <td className="text-right">{product.barcode}</td>
                            </tr> : null}
                            </tbody>
                        </table>
                    </div>
                </Col>
            </Row>
        </section>
    )
}

AdditionalTable.propTypes = {
    product: PropTypes.object
}

const TitleSection = ({product}) => (
    <section className="product-title mb0 pb0">
        {/*product.extras.uvstabil && <div className={"fr"}>
            <Image width={80} src={"/uvstabil_sgn_web_k.png"}/>
</div>*/}

        <div className="brand">{product.extras.herst !== "unbekannt" &&
        <Link to={`/brand/${product.extras.herst}`}>{product.extras.herst}</Link>}</div>

        <div className="title">{product.desc.short_des}</div>
        <div className="id pt2 pb2">{translate("Artikel-Nr.")}: {product.article_nr || product.article_id}</div>

        {/*{(product.showDeliveryDate && product.extras.liefab) && <Message color={"green"}>Lieferbar ab: {product.extras.liefab}</Message>}*/}
        {product.extras.statusinfo && <Message>{product.extras.statusinfo}</Message>}
        {/*{product.extras.uvstabil && <Message color={"green"}>*/}
        {/*  <div><Icon name={"checkmark"}/> UV-Stabil</div>*/}
        {/*</Message>}   */}


        {/* Price*/}
        {shop.session && <ProductPrice product={product}/>}

        {/* Availability*/}
        {shop.config.useAvailability !== false && <Availability product={product}/>}
        {/*<Availability product={product}/>*/}
    </section>
)

TitleSection.propTypes = {
    product: PropTypes.object
}

const Availability = ({product}) => {
    let notice = product.getNotice()
    return (
        <div className="availability">
            {notice}
        </div>
    )
}

const ActionSection = ({product, onChange, onAdd}) => {
    if (!product.canBeBought) return null
    const list = shop.orderlist.default
    return (
        <section className="product-actions pt2 pb4">
            <div style={{display: "inline-block "}}>
                <p>
                    {product.count * product.unit_multi} Stück <Price
                    className="f5 fw2 black-50">{product.count * product.unit_multi * product.price}</Price></p>
                <ProductQuantityGroup product={product}
                                      list={list}
                                      showVE={false}
                                      onChange={onChange}
                                      onAdd={onAdd}
                                      large/>
            </div>
        </section>
    )
}

ActionSection.propTypes = {
    product: PropTypes.object,
    onChange: PropTypes.func,
    onAdd: PropTypes.func,
}

const DescriptionSection = ({product}) => (
    <section className="description pv3 lh-copy">
        {product.desc.des}
    </section>
)
DescriptionSection.propTypes = {
    product: PropTypes.object,
}

const HtmlDescriptionSection = ( { product } ) => (
  <section className="description pv3 lh-copy" dangerouslySetInnerHTML={{ __html: product.desc.des }}>
  </section>
)

HtmlDescriptionSection.propTypes = {
  product: PropTypes.object,
}


ProductImages.propTypes = {
    images: PropTypes.any,
    image: PropTypes.any,
    onClick: PropTypes.func,
}



// WEBPACK FOOTER //
// ./src/theme/fiebiger/pages/ProductPage.js